import { render, staticRenderFns } from "./OurWebsites.vue?vue&type=template&id=a741cca0&scoped=true"
import script from "./OurWebsites.vue?vue&type=script&lang=ts"
export * from "./OurWebsites.vue?vue&type=script&lang=ts"
import style0 from "./OurWebsites.vue?vue&type=style&index=0&id=a741cca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a741cca0",
  null
  
)

export default component.exports